const CONFIG = {
  ASSET_PATH: "/Universe-Component-Library/general",
  COMPONENT_BUCKET: "https://cdn.gonoodle.com",
};

export default CONFIG;
